import { QueryParams } from "@router/route-params";
import { setIsAlphaTestingEnabled, setIsBetaTestingEnabled, setIsDevModeEnabled } from "@store/app/app-slice";

/** Allowed dev tool keys */

/** Allowed credential keys */

/** Control types for dev tools */

/** Type definition for the callback of toggle features or toggle tools */

/** Type definition for the callback of button dev tools */

/** Type definition for the callback of credentials dev tools */

/** Union type for items in the features table */

/**
 * Feature configuration object for development features
 */
export const FEATURES = [{
  label: "Dev Mode",
  description: "Enables features for developers and internal users that won't be released to customers",
  queryParam: QueryParams.enableDev,
  appStateKey: "isDevModeEnabled",
  setEnabledAction: setIsDevModeEnabled
}, {
  label: "Alpha",
  description: "Enables features that are currently in development and may be incomplete, partially implemented, or not functioning as expected.",
  queryParam: QueryParams.enableAlpha,
  appStateKey: "isAlphaTestingEnabled",
  setEnabledAction: setIsAlphaTestingEnabled
}, {
  label: "Beta",
  description: "Enables features that are mostly complete but not yet ready for release to customers.",
  queryParam: QueryParams.enableBeta,
  appStateKey: "isBetaTestingEnabled",
  setEnabledAction: setIsBetaTestingEnabled
}];
export const DEV_TOOLS = [{
  label: "Open Admin Panel",
  description: "Opens the admin panel in a new tab with the current workspace.",
  buttonText: "Open",
  action: "openAdminPanel",
  controlType: "button"
}, {
  label: "Clear Cookies",
  description: "Removes all stored cookies for the holobuilder domain.",
  buttonText: "Clear",
  action: "clearCookies",
  controlType: "button"
}, {
  label: "Reset FUE Flags",
  description: "Resets first user experience flags to show all splash-screens.",
  buttonText: "Reset",
  action: "resetFueFlags",
  controlType: "button"
}, {
  label: "Send Error to Sentry",
  description: "Sends a test error to Sentry with a unique identifier for verification.",
  buttonText: "Send",
  action: "sendTestSentryError",
  controlType: "button"
}, {
  label: "Allow localize translations",
  description: "Allows sending translation strings to Localize from this environment, regardless of whether it’s a numbered environment or localhost. This feature remains active only until the page is refreshed.",
  action: "allowLocalizeTranslations",
  featureStateKey: "isTranslationOverrideAllowed",
  controlType: "toggle"
}, {
  label: "Theme Mode",
  description: "Select light, dark, or system theme. Mirrors the account preferences page and persists as your user setting.",
  action: "themeMode",
  controlType: "themeMode"
}, {
  label: "Enable Sentry",
  description: "Allows sending errors to Sentry from numbered environments or localhost. By default, errors are only sent from production environments.",
  action: "enableSentry",
  featureStateKey: "isSentryEnabled",
  controlType: "toggle"
}, {
  label: "Send product feedback to Teams",
  description: "Allows sending the product feedback (e.g. when switching back to the legacy UI) to the Teams channel from internal users in any environment. By default, it's only allowed from non-internal users in production environments.",
  action: "enableProductFeedback",
  featureStateKey: "isProductFeedbackEnabled",
  controlType: "toggle"
}];
export const CREDENTIALS = [{
  label: "Analytics API Credentials",
  description: "Temporary basic-auth credentials for the Analytics API, stored in local storage and used until JWT auth is implemented. The page reloads after saving so the new credentials take effect.",
  action: "saveAnalyticsCredentials"
}];

/** Test error message constant that is sent to Sentry */
export const TEST_ERROR_MESSAGE = "DASHBOARD_TEST_SENTRY_ERROR";